/**
 * Next selected-target set when GET_CHANNEL has settled.
 * If the user edited during load, unions server targets with prior UI selection (additive).
 */
export function mergeChannelTargetsOnLoad(
  serverTargetIds: Set<string>,
  previousSelected: Set<string>,
  editedDuringChannelLoad: boolean,
): Set<string> {
  if (!editedDuringChannelLoad) {
    return new Set(serverTargetIds);
  }
  const merged = new Set(serverTargetIds);
  for (const id of previousSelected) {
    merged.add(id);
  }
  return merged;
}
